import Icon from "@components/ui/icon";
import { cn } from "@lib/cn";
import { useState } from "react";
import { UserMenuAccountSearch } from "./user-menu-account-search";
import { UserMenuAdminTypeSelect } from "./user-menu-admin-type-select";

export const UserMenuAdminSettings = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="tw-border-t tw-border-solid tw-border-blue-100 tw-px-2 tw-pt-1 tw-mt-1">
      <button
        type="button"
        className="tw-flex tw-cursor-pointer tw-items-center tw-w-full tw-text-sm tw-py-1.5 tw-px-1 tw-font-normal tw-text-blue-500 tw-transition-colors"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        Admin
        <Icon
          icon="ri-arrow-down-s-line"
          className={cn("tw-text-blue-500 tw-ml-auto tw-transition-transform", {
            "tw-rotate-180": isOpen,
          })}
        />
      </button>
      <div
        className="tw-grid tw-transition-[grid-template-rows] tw-duration-200"
        style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
      >
        <div className="tw-overflow-hidden -tw-mx-1 tw-px-1">
          <div>
            <UserMenuAdminTypeSelect />
            <UserMenuAccountSearch />
          </div>
        </div>
      </div>
    </div>
  );
};
